import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Formik } from "formik";
import InputWrapper from "./InputWrapper";
import ButtonWrapper from "./ButtonWrapper";
import SelectWrapper from "./SelectWrapper";
import { useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import postQrInitManualTransaction from "../redux/actions/postQrInitManual";
import * as Yup from "yup";
import { bankNames, toLocaleStringFormate } from "../helpingFunctions";
import { language } from "../utils/language";
import MainWrapper from "./MainWrapper";
import WarningModal from "./WarningModal";
import { Fade, Reveal, Slide } from "react-awesome-reveal";
import getVerifyManualTransaction from "../redux/actions/getVerifyManualTransaction";
import LanugageSelector from "./LanugageSelector";
import { CloseCircleOutlined } from "@ant-design/icons";

const CardWrapper = styled(Slide)`
  height: auto;
  z-index: 999;
  @media (min-width: 280px) and (max-width: 768px) {
    width: 90%;
  }
  width: 30%;
  background: #fff;
  // padding: 20px 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  // border-bottom-left-radius: 10px;
  // border-bottom-right-radius: 10px;
  overflow: hidden;
  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
`;

const TrueMoneyForm = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { lang } = useSelector((state) => state.languageSelectorReducer);

  const { modalShow, modalData } = useSelector(
    (state) => state.warningModalReducer
  ); //Warning modal data

  const transactionSchema = Yup.object().shape({
    accountNo: Yup.string()
      .matches(/^[0-9\s]+$/, "Only Numeric are allowed for this field")
      .min(4, language[lang].trueMoneyForm.INPUT_ERROR)
      .max(4, language[lang].trueMoneyForm.INPUT_ERROR)
      .required(language[lang].trueMoneyForm.INPUT_ERROR),
  });

  // -----checking link is verify or not---------
  const { error } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );

  useEffect(() => {
    dispatch(getVerifyManualTransaction(params.id));
  }, []);

  useEffect(() => {
    if (error) {
      navigate(`/${params.id}`);
    }
  }, [error]);

  return (
    <div className="" style={{ height: "100vh" }}>
      <WarningModal
        visible={modalShow}
        lang={lang}
        closeIcon={
          <CloseCircleOutlined
            style={{ position: "absolute", right: 10, top: 10 }}
            onClick={() =>
              dispatch({
                type: "WARNING_MODAL_CLOSE",
                payLoad: false,
                data: "",
              })
            }
          />
        }
        maskClosable={false}
        // centered={true}
        footer={null}
        bodyStyle={{ borderRadius: 10 }}
        width={380}
      />
      <MainWrapper>
        <CardWrapper className="">
          <div className="card-header w-100">
            <h3 className="text-center">{language[lang].trueMoneyForm.PTI}</h3>
          </div>
          <Formik
            initialValues={{
              accountNo: "",
            }}
            validationSchema={transactionSchema}
            onSubmit={(values) => {
              let qrManualTransactionParams = {
                qrCodeTransactionId: data.trxRef,
                type: window.location?.pathname?.split("/")[2]?.split("-")[0],
                amount: parseFloat(data?.amount),
                sessionId: data.sessionToken,
                bankCode: "022",
                bankName: "True Money Co. Ltd.(CIMB)",
                accountNumber: values.accountNo,
                userId: data.merchantId,
              };
              if (values && data.merchantId) {
                dispatch({
                  type: "WARNING_MODAL_SHOW",
                  payLoad: true,
                  data: qrManualTransactionParams,
                });
              }
            }}
            enableReinitialize={true}
          >
            {({
              onSubmit,
              values,
              errors,
              handleChange,
              handleSubmit,
              resetForm,
            }) => (
              <form noValidate onSubmit={handleSubmit} className="w-100 p-3">
                <div className="d-flex justify-content-end">
                  <LanugageSelector />
                </div>
                <p className="label mb-0 fw-bold">
                  {language[lang].trueMoneyForm.INPUT_TITLE}*
                </p>
                <InputWrapper
                  style={{ borderRadius: 10, marginTop: 0 }}
                  name="accountNo"
                  type="text"
                  size="large"
                  value={values.accountNo}
                  onChange={handleChange("accountNo")}
                  placeholder={language[lang].trueMoneyForm.INPUT_PLACEHOLDER}
                />
                {errors.accountNo ? (
                  <p className="mb-4" style={{ color: "red" }}>
                    {errors.accountNo}
                  </p>
                ) : (
                  <p className="mb-4"></p>
                )}

                <div className="d-flex ">
                  <p className="label fw-bold mb-0">
                    {language[lang].trueMoneyForm.AMOUNT} (฿)*
                  </p>
                  <p className="label fw-bold mb-0 ms-5">
                    {toLocaleStringFormate(data?.amount)}
                  </p>
                </div>

                <div className="w-100">
                  <ButtonWrapper
                    border={true}
                    size="middle"
                    height="40px"
                    htmlType="submit"
                    className="w-100 mt-4"
                    text={language[lang].trueMoneyForm.BTN_TEXT}
                  />
                </div>
              </form>
            )}
          </Formik>
        </CardWrapper>
      </MainWrapper>
    </div>
  );
};

export default TrueMoneyForm;
